/**
 * Free paddle cover - clean-up (v5)
 *
 * The factory packs a cover with every Swift Pro, so the cover is no longer
 * added to the cart as a separate line. This script only tidies carts left
 * over from the old offer: it removes any cover line tagged _free_gift and
 * the FREEPADDLECOVER code, then reloads once if anything was removed.
 */
(function () {
  if (window.freeCoverCleanupRan) return;
  window.freeCoverCleanupRan = true;

  var CODE = 'FREEPADDLECOVER';

  try {
    localStorage.removeItem('freeGiftTimerEnd');
    localStorage.removeItem('freeGiftExpired');
  } catch (e) {}

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var steps = [];
      (cart.items || []).forEach(function (i) {
        if (i.properties && String(i.properties._free_gift) === 'true') {
          steps.push(function () { return post('/cart/change.js', { id: i.key, quantity: 0 }); });
        }
      });
      var codes = (cart.discount_codes || []).filter(function (d) { return d && d.code; });
      var hasCode = codes.some(function (d) { return d.code.toUpperCase() === CODE; });
      if (hasCode) {
        var keep = codes
          .filter(function (d) { return d.code.toUpperCase() !== CODE && d.applicable !== false; })
          .map(function (d) { return d.code; });
        steps.push(function () { return post('/cart/update.js', { discount: keep.join(',') }); });
      }
      if (!steps.length) return;
      return steps
        .reduce(function (p, step) { return p.then(step); }, Promise.resolve())
        .then(function () {
          // Reload at most once per visit, so a failed removal can never loop
          var done = null;
          try { done = sessionStorage.getItem('freeCoverCleanupReloaded'); } catch (e) {}
          if (done === 'true') return;
          try { sessionStorage.setItem('freeCoverCleanupReloaded', 'true'); } catch (e) {}
          window.location.reload();
        });
    })
    .catch(function () {});
})();
